import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ErrorComponent } from './feature/error/error.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./feature/shell/shell.module').then((m) => m.ShellModule),
  },
  { path: '**', component: ErrorComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
